import { render } from "./UploadModal.vue?vue&type=template&id=3003c0e6&ts=true"
import script from "./UploadModal.vue?vue&type=script&lang=ts"
export * from "./UploadModal.vue?vue&type=script&lang=ts"

import "./UploadModal.vue?vue&type=style&index=0&id=3003c0e6&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__